import { render, staticRenderFns } from "./k520c-provider.vue?vue&type=template&id=b0fe4cae&scoped=true&"
import script from "./k520c-provider.vue?vue&type=script&lang=js&"
export * from "./k520c-provider.vue?vue&type=script&lang=js&"
import style0 from "./k520c-provider.vue?vue&type=style&index=0&id=b0fe4cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fe4cae",
  null
  
)

export default component.exports